import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'modal',
    'modalTitle',
    'modalDescription',
    'uploadForm',
    'deleteForm',
    'form',
    'deleteFormElement',
    'fileInput',
    'uploadPrompt',
    'preview',
    'previewImg',
    'submitButton',
    'submitText'
  ]

  openAdd() {
    this.showModal(
      'Upload Logo',
      'Choose an image file to upload as the jurisdiction logo.'
    )
    this.showUploadForm()
  }

  openEdit() {
    this.showModal(
      'Update Logo',
      'Choose a new image file to replace the current logo.'
    )
    this.showUploadForm()
  }

  openDelete() {
    this.showModal(
      'Delete Logo',
      'Are you sure you want to delete the current logo?'
    )
    this.showDeleteForm()
  }

  showModal(title, description) {
    this.modalTitleTarget.textContent = title
    this.modalDescriptionTarget.textContent = description
    this.modalTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  showUploadForm() {
    this.uploadFormTarget.classList.remove('hidden')
    this.deleteFormTarget.classList.add('hidden')
    this.submitTextTarget.textContent = 'Upload Logo'
    this.submitButtonTarget.classList.remove('bg-red-600', 'hover:bg-red-500')
    this.submitButtonTarget.classList.add(
      'bg-indigo-600',
      'hover:bg-indigo-500'
    )
  }

  showDeleteForm() {
    this.uploadFormTarget.classList.add('hidden')
    this.deleteFormTarget.classList.remove('hidden')
    this.submitTextTarget.textContent = 'Delete Logo'
    this.submitButtonTarget.classList.remove(
      'bg-indigo-600',
      'hover:bg-indigo-500'
    )
    this.submitButtonTarget.classList.add('bg-red-600', 'hover:bg-red-500')
  }

  close() {
    this.modalTarget.classList.add('hidden')
    document.body.style.overflow = ''
    this.resetForm()
  }

  clickUpload() {
    this.fileInputTarget.click()
  }

  previewImage(event) {
    const input = event.target
    const preview = this.previewTarget
    const previewImg = this.previewImgTarget
    const uploadPrompt = this.uploadPromptTarget

    if (input.files && input.files[0]) {
      const reader = new FileReader()

      reader.onload = function (e) {
        previewImg.src = e.target.result
        preview.classList.remove('hidden')
        uploadPrompt.classList.add('hidden')
      }.bind(this)

      reader.readAsDataURL(input.files[0])
    } else {
      preview.classList.add('hidden')
      uploadPrompt.classList.remove('hidden')
    }
  }

  submitForm() {
    if (this.deleteFormTarget.classList.contains('hidden')) {
      // Upload form
      this.formTarget.submit()
    } else {
      // Delete form
      this.deleteFormElementTarget.submit()
    }
  }

  resetForm() {
    // Reset file input
    this.fileInputTarget.value = ''

    // Hide preview and show upload prompt
    this.previewTarget.classList.add('hidden')
    this.uploadPromptTarget.classList.remove('hidden')

    // Reset to upload form
    this.showUploadForm()
  }
}
